/**
 * Example swiper container
 * <div data-swiper-id="<?= $this->id ?>" class="swiper-container" data-swiper="portfolio_modal">
 *     <div class="swiper-wrapper">
 *          <div class="swiper-slide">
 *               MEIN SLIDER CONTENT
 *           </div>
 *       </div>
 *       <div class="swiper-navigation">
 *           <div class="swiper-button swiper-button-prev">{{svg::icon-arrow-left}}</div>
 *           <div class="swiper-button swiper-button-next">{{svg::icon-arrow-right}}</div>
 *       </div>
 *     </div>
 */

let slider = {


    init: () => {

        slider.selector = '.swiper-container';
        slider.elements = document.querySelectorAll(slider.selector);
        slider.attemptActionIfNotEmpty(slider.ready);

        window.addEventListener('load', () => {
            slider.attemptActionIfNotEmpty(slider.loaded);
        });
    },

    attemptActionIfNotEmpty: function (action) {
        if (slider.elements && slider.elements.length > 0) {
            action();
        }
    },

    ready: () => {

        window.ppSlider = [];
        slider.elements.forEach((element, index) => {

            const swiperId = element.dataset.swiperId;

            //newslist swiper config
            if (element.dataset.swiper === "newslist") {
                window.ppSlider[index] = new Swiper(element, {
                    spaceBetween: 30,
                    slidesPerView: 'auto',
                    slideClass: 'block',
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        480: {
                            slidesPerView: 2,
                        },
                        768: {
                            slidesPerView: 3,
                        }
                    }
                });
            } else {

                // default swiper config
                window.ppSlider[index] = new Swiper(element, {
                    spaceBetween: 30,
                    slidesPerView: 'auto',
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }
                });
            }
        });
    },

    loaded: function () {

    }

};

export default slider.init();
